<template>
  <!-- ========== MINI-FAQ ========== -->
  <section class="k-sec alt reveal" id="faq">
    <div class="k-head">
      <span class="k-eyebrow">Kurz beantwortet</span>
      <h2>Was du <span class="grad">wissen willst</span>.</h2>
    </div>
    <div class="kf" data-kf>
      <details id="faq-social">
        <summary>Kann ich mich mit Google, Apple oder Facebook anmelden?</summary>
        <div class="a"><p>Ja. Ein Tipp genügt, dann bist du dabei — ganz ohne neues Passwort. Wenn dir das lieber ist, geht es auch klassisch mit E-Mail und Passwort.</p></div>
      </details>
      <details id="faq-dauer">
        <summary>Wie lange dauert die Registrierung?</summary>
        <div class="a"><p>Etwa eine Minute. Ein paar kurze Fragen zu dir, damit die Vorschläge passen — zurück kannst du dabei jederzeit.</p></div>
      </details>
      <details id="faq-wer">
        <summary>Wer kann mitmachen?</summary>
        <div class="a"><p>Alle ab 18 aus Deutschland, Österreich und der Schweiz. Mehr brauchst du nicht — außer Lust auf gute Gespräche.</p></div>
      </details>
      <details id="faq-danach">
        <summary>Was passiert direkt nach der Anmeldung?</summary>
        <div class="a"><p>Du kannst sofort Profile ansehen und losschreiben. Die Community ist rund um die Uhr aktiv — dein erstes Hallo bleibt nicht liegen.</p></div>
      </details>
    </div>
  </section>
</template>

<script>
export default {
  name: 'KennenlernenFaqSection',
};
</script>
